import React from 'react';
import { EditButton } from 'react-admin';
import { ActionsContainer } from '../../../../components';

import ActionsMenu from './ActionsMenu';
import ContractMenu from './ContractMenu/ContractMenu';
import DownloadMenu from './DownloadMenu';
import UploadDocumentDialog from './UploadDocumentDialog';
import LRARButton from './LRARButton';
// import TeleverserButton from './TeleverserButton';
import TakenOverMenu from './TakenOverMenu';
import DismissalConvocationDialog from './DismissalConvocationDialog';
import AffectattentionDialog from './AffectattentionDialog';
import VivierBanner from '../VivierBanner';

// Plan 036 (frontière vivier), P4: react-admin v3's <ShowView> clones the
// `actions` element with `__assign({ data: record, ... }, finalActions.props)`
// (ra-ui-materialui/lib/detail/ShowView.js) — any own enumerable key on
// `finalActions.props`, including a `defaultProps`-injected `data: undefined`,
// overwrites `data: record` because Object.assign copies undefined values too.
// Do NOT add propTypes/defaultProps for `data` on this component: that is
// exactly what silently deleted the whole actions bar (no Modifier button, no
// Actions menu, etc.) in production. eslint-disable-next-line covers the
// missing propTypes instead.
// eslint-disable-next-line react/prop-types
const ShowActions = (props) => {
  return (
    <>
      <VivierBanner record={props.data} />
      <ActionsContainer {...props}>
        <EditButton />
        <ActionsMenu />
        <ContractMenu />
        <DownloadMenu />
        <TakenOverMenu />
        <UploadDocumentDialog />
        <LRARButton />
        <AffectattentionDialog />
        <DismissalConvocationDialog />
      </ActionsContainer>
    </>
  );
  /*
  return (
    <ActionsContainer {...props}>
      <EditButton />
      <ActionsMenu />
      <DownloadMenu />
      <TakenOverMenu />
      <TeleverserButton />
      <LRARButton />
      <AffectattentionDialog />
      <DismissalConvocationDialog />
    </ActionsContainer>
  );
    */
};

export default ShowActions;
